<template>
  <div class="py-1">
    <MenuOption
      id="approve-only"
      :title="$t('W: Godkend uden at sende')"
      @select="onApproveOnlyClick">
      <template #icon>
        <IconLucideCheck class="h-4 w-4" />
      </template>
    </MenuOption>
    <!-- The disabled option ignores the pointer, so the reason hangs on this wrapper instead. -->
    <div v-tooltip="canSchedule ? '' : $t('W: Leveringen kan ikke planlægges')">
      <MenuOption
        id="approve-and-schedule"
        :title="$t('W: Godkend og planlæg')"
        :isDisabled="!canSchedule"
        @select="onApproveAndScheduleClick">
        <template #icon>
          <IconLucideCalendarClock class="h-4 w-4" />
        </template>
      </MenuOption>
    </div>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'

/**
 * The alternatives to "Godkend og send" on a delivery, behind the split button's chevron.
 *
 * "Godkend uden at sende" says what does not happen, so it matches the "Godkendt – ikke sendt"
 * chip it leaves behind; a wrong pick is visible and one click to correct with the "Send" button.
 * (It was a bare "Godkend" until 2026-10-19 — read alone, it did not say that nothing is sent.)
 *
 * Every option is always listed. "Godkend og planlæg" is greyed out, not removed, when it cannot be
 * used (a walk-in TAT, or a send moment already passed), so the menu does not look like it is
 * missing something.
 */
export default {
  name: 'OrderApproveOptionsMenu',

  emits: ['close'],

  props: {
    onApproveOnly: { type: Function as PropType<() => void>, required: true },
    onApproveAndSchedule: {
      type: Function as PropType<() => void>,
      required: true,
    },
    /**
     * False for a walk-in TAT, and once the send moment has passed — there is nothing left to
     * wait for, so the option is shown disabled.
     */
    canSchedule: { type: Boolean, default: false },
  },

  methods: {
    onApproveOnlyClick(): void {
      this.onApproveOnly()
      this.$emit('close')
    },

    onApproveAndScheduleClick(): void {
      this.onApproveAndSchedule()
      this.$emit('close')
    },
  },
}
</script>
